import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import RevShareModal from "../../common/overrides/RevShareModal";
import { Form } from "react-bootstrap";
import FormRow from "../../common/forms/FormRow";
import PlainTextField from "../../common/forms/PlainTextField";
import NumericInput from "../../common/forms/NumericInput";
import DollarValueInput from "../../common/forms/DollarValueInput";
import { editAvailableHours, loadAvailableHoursNotes } from "../../../redux/actions/AvailableHoursActions";

class AdminEditModal extends React.Component {
  render() {
    return (
      <RevShareModal
        buttonText="Edit"
        buttonVariant="primary"
        key={`${this.props.AvailableHoursRecord.consultantName}_${this.props.AvailableHoursRecord.earnedOn}_editModal`}
        title="Edit Available RevShare"
        validation={this.validate}
        yesButtonOnClick={this.submit}
      >
        <Form noValidate>
          <FormRow
            columns={[
              <PlainTextField inline label="Consultant" value={this.props.AvailableHoursRecord.consultantName} />,
              <PlainTextField inline label="Earned" value={this.props.AvailableHoursRecord.earnedOn} />,
            ]}
          />
          <FormRow
            columns={[
              <PlainTextField inline label="Hours" value={this.props.AvailableHoursRecord.hours} />,
              <PlainTextField inline label="Rate" value={this.props.AvailableHoursRecord.rate} />,
            ]}
          />
          <FormRow
            columns={[
              <NumericInput
                key={`${this.props.AvailableHoursRecord.consultantName}_${this.props.AvailableHoursRecord.earnedOn}_hoursEdit`}
                label="Hours"
                onChange={this.onChange}
                ref={(element) => (this.hoursField = element)}
                value={this.state.hours ? this.state.hours : this.props.AvailableHoursRecord.hours}
              />,
              <DollarValueInput
                key={`${this.props.AvailableHoursRecord.consultantName}_${this.props.AvailableHoursRecord.earnedOn}_rateEdit`}
                label="Rate"
                onChange={this.onChange}
                ref={(element) => (this.rateField = element)}
                value={this.state.rate ? this.state.rate : this.props.AvailableHoursRecord.rateValue}
              />,
            ]}
          />
          <FormRow
            columns={[
              <Form.Group>
                <Form.Label>Note</Form.Label>
                <Form.Control
                  as="textarea"
                  onChange={this.onChange}
                  ref={(element) => (this.noteEntry = element)}
                        rows="5"
                        placeholder="*Required"
                  value={this.state.note.text}
                ></Form.Control>
              </Form.Group>,
            ]}
          />
        </Form>
      </RevShareModal>
    );
  }

  constructor(props) {
    super(props);
    this.state = {
      hours: null,
      note: "",
      rate: null,
    };

    this.onChange = this.onChange.bind(this);
    this.validate = this.validate.bind(this);
    this.submit = this.submit.bind(this);
  }

  onChange() {
    this.setState({
      hours: parseFloat(this.hoursField.value),
      note: this.noteEntry.value,
      rate: parseFloat(this.rateField.value),
    });
  }

  validate() {
    return (
      (this.state.hours !== this.props.AvailableHoursRecord.hours ||
        this.state.rate !== this.props.AvailableHoursRecord.rateValue) &&
      this.state.note.length > 0
    );
  }

  submit() {
    const result = {
      hours: this.state.hours || this.state.hours === 0 ? this.state.hours : this.props.AvailableHoursRecord.hours,
      note: this.state.note,
      rate: this.state.rate ? this.state.rate : this.props.AvailableHoursRecord.rateValue,
    };
    return this.props.edit(this.props.AvailableHoursRecord.id, result).then(() => {
      this.props.getNotes(this.props.AvailableHoursRecord.id);
      this.setState({ hours: null, note: "", rate: null });
    });
  }
}

AdminEditModal.propTypes = {
  AvailableHoursRecord: PropTypes.object.isRequired,
};

function mapStateToProps(state, ownProps) {
  return {};
}

const mapDispatchToProps = {
  edit: editAvailableHours,
  getNotes: loadAvailableHoursNotes,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminEditModal);
